import { AuthGuard } from "../../shared/guards/AuthGuard";
import { Sidebar } from "../../shared/components";
import { CreditRecoveryListPresentation } from "./components/CreditRecoveryListPresentation";

export const CreditRecoveryPage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<CreditRecoveryListPresentation />
			</Sidebar>
		</AuthGuard>
	);
};
